import { Injectable } from '@angular/core';
import { CreateRewardsProgramPreferenceSuccess } from '@features/rewards-program/store/actions/rewards-program-preference.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';
import { BroadcastService } from '../services/broadcast.service';
import { BroadcastListeners } from '../types';
import { BroadCastEvent, BroadCastListener } from './action';

@Injectable()
export class BroadcastEffects {
  constructor(
    private actions$: Actions,
    private broadcastService: BroadcastService,
    private store: Store,
  ) {
    // Break pull use case in this specific scenario
    this.broadcastService.registerMessageHandler((data) => {
      return this.store.dispatch(data);
    });
  }

  // This handles broadcasting to other tabs
  broadCastEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(BroadCastEvent),
        tap(({ payload }) => {
          this.broadcastService.postMessage(payload);
        }),
      ),
    { dispatch: false },
  );

  // TODO: Register effects to dispatch BroadCastEvent
  /**
  example
   broadCastEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS),
      map(action) =>  BroadCastEvent(action),
    ),
  )
   */
  //
  rewardsProgramChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateRewardsProgramPreferenceSuccess),
      map((action) =>
        BroadCastEvent({
          payload: BroadCastListener({
            listener: BroadcastListeners.REWARDS_PROGRAM_PREFERENCE_LISTENER,
            data: null,
          }),
        }),
      ),
    ),
  );
}
